import React from 'react';
import { connect } from 'react-redux';
import CartPanel from '../components/CartPanel';
import { setCartName, fetchIsBatchDownloadOk, updateCheckedObjectsInCart, logCartDownloadClick, emptyCart, restorePriorCart } from '../actions/cart';
import { formatBytes, getLastSegmentsInUrls } from '../utils';
import { removeFromCart, updateRoute } from "../actions/common";
import Message from '../components/ui/Message';
import DownloadButton from '../components/buttons/DownloadButton';
import { useDownloadInfo } from '../hooks/useDownloadInfo';
function DataCart(props) {
    function handlePreview(urls) {
        props.updateRoute('preview', getLastSegmentsInUrls(urls));
    }
    function handleRouteClick(newRoute) {
        props.updateCheckedObjectsInCart([]);
        props.updateRoute(newRoute);
    }
    function handleAllCheckboxesChange() {
        if (props.checkedObjectsInCart.length > 0) {
            props.updateCheckedObjectsInCart([]);
        }
        else {
            const checkedObjects = props.cart.items.map(item => item.dobj);
            props.updateCheckedObjectsInCart(checkedObjects);
        }
    }
    function handleDownload() {
        logCartDownloadClick(filename, hashes);
        props.emptyCart(filename);
    }
    function handleRestore() {
        props.restorePriorCart();
    }
    const { preview, user, cart, priorCart, updateCheckedObjectsInCart, extendedDobjInfo, labelLookup } = props;
    const localObjectsTable = props.cart.items.flatMap((x) => x.knownDataObject ? [x.knownDataObject] : []);
    const downloadInfo = useDownloadInfo({ readyObjectIds: localObjectsTable.map((x) => x.dobj),
        objectsTable: localObjectsTable, extendedDobjInfo, labelLookup });
    const previewitemId = preview.item ? preview.item.dobj : undefined;
    const downloadTitle = user.email && user.profile.icosLicenceOk
        ? 'Download cart content'
        : 'Accept license and download cart content';
    const filename = cart.count == 0 && priorCart ? priorCart.name : (cart.name ? cart.name : downloadInfo.filename);
    const hashes = cart.count == 0 && priorCart ? priorCart.pids : cart.pids;
    const showCartPanel = !cart.isInitialized || cart.count > 0;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: showCartPanel ? {} : { display: "none" } },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-sm-8 col-lg-9" },
                    React.createElement(CartPanel, { previewitemId: previewitemId, previewItemAction: handlePreview, updateCheckedObjects: updateCheckedObjectsInCart, handleAllCheckboxesChange: handleAllCheckboxesChange, downloadInfo: downloadInfo, ...props })),
                React.createElement("div", { className: "col-sm-4 col-lg-3" },
                    React.createElement("div", { className: "card" },
                        React.createElement("div", { className: "card-header" }, downloadTitle),
                        React.createElement("div", { className: "card-body text-center" },
                            React.createElement(DownloadButton, { style: {}, filename: filename, readyObjectIds: hashes, enabled: true, onSubmitHandler: handleDownload }),
                            React.createElement("div", { className: 'mt-2', style: { textAlign: 'center', fontSize: '90%' } },
                                "Total size: ",
                                formatBytes(cart.size),
                                " (uncompressed)")))))),
        React.createElement("div", { style: showCartPanel ? { display: "none" } : {} },
            React.createElement(Message, { title: "Your cart is empty", findData: () => handleRouteClick('search'), restorePriorCart: priorCart ? handleRestore : undefined }))));
}
function stateToProps(state) {
    return {
        cart: state.cart,
        priorCart: state.priorCart,
        previewLookup: state.previewLookup,
        labelLookup: state.labelLookup,
        user: state.user,
        preview: state.preview,
        checkedObjectsInCart: state.checkedObjectsInCart,
        extendedDobjInfo: state.extendedDobjInfo,
    };
}
function dispatchToProps(dispatch) {
    return {
        updateRoute: (route, previewPids) => dispatch(updateRoute(route, previewPids)),
        setCartName: (newName) => dispatch(setCartName(newName)),
        fetchIsBatchDownloadOk: () => dispatch(fetchIsBatchDownloadOk),
        updateCheckedObjectsInCart: (ids) => dispatch(updateCheckedObjectsInCart(ids)),
        removeFromCart: (ids) => dispatch(removeFromCart(ids)),
        emptyCart: (filename) => dispatch(emptyCart(filename)),
        restorePriorCart: () => dispatch(restorePriorCart())
    };
}
export default connect(stateToProps, dispatchToProps)(DataCart);
